
(function () {
  function polishGoldenHomePrices() {
    document.querySelectorAll('#goldenHomeTrendingTabs .ghProductPrice').forEach(function (wrap) {
      var main = wrap.querySelector('.ghMainPrice');
      var compare = wrap.querySelector('.ghComparePrice');

      if (main) {
        var amount = main.querySelector('.ghPriceAmount');
        var currency = main.querySelector('.ghPriceCurrency');

        main.style.background = 'transparent';
        main.style.display = 'grid';
        main.style.gridTemplateColumns = 'auto minmax(0, 1fr)';
        main.style.alignItems = 'center';

        if (currency) {
          currency.style.background = '#000000';
          currency.style.color = '#ffffff';
        }

        if (amount) {
          amount.style.color = '#d60000';
          amount.style.textAlign = 'right';
          amount.style.justifySelf = 'end';
        }
      }

      if (compare && !compare.classList.contains('isEmpty')) {
        compare.style.justifyContent = 'flex-end';
        compare.style.textAlign = 'right';
        compare.querySelectorAll('.ghPriceCurrency, .ghPriceAmount').forEach(function (el) {
          el.style.color = '#666666';
          el.style.textDecoration = 'line-through';
          el.style.textAlign = 'right';
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', polishGoldenHomePrices);
  } else {
    polishGoldenHomePrices();
  }

  document.addEventListener('shopify:section:load', polishGoldenHomePrices);
  window.addEventListener('resize', polishGoldenHomePrices);
})();
